import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UploadFileService {

    constructor() { }

    uploadfile(file, folder, bucketName = 'focus-crm-staticfiles-eu'): S3.ManagedUpload {
        bucketName = 'focus-crm-staticfiles-eu'
        const bucket = new S3(
            {
                // accessKeyId: 'AKIAJHK772AGZVJM4NQQ',
                // secretAccessKey: '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',
                // region: 'eu-west-2'
                accessKeyId: 'AKIA4EJ4U3VWFYXLHDK4',
                secretAccessKey: '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',                
                region: 'eu-west-1'
            }
        );

        const params = {
            Bucket: bucketName,
            Key: folder + '/' + file.name,
            Body: file
        };

        // create & return the promise
        return bucket.upload(params);

    }

    // downloadFile(key) {

    //     const bucket = new S3(
    //         {
    //             accessKeyId: 'AKIAJHK772AGZVJM4NQQ',
    //             secretAccessKey: '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',
    //             region: 'eu-west-2'
    //         }
    //     );

    //     const params = {
    //         Bucket: 'blueboxcrmstaticfileseu',
    //         Key: key
    //     };

    //     // const file = require('fs').createWriteStream('/path/to/file.jpg');

    //     // create & return the promise
    //     return bucket.getObject(params);
    //     // .createReadStream().pipe(file);

    // }


}



// WEBPACK FOOTER //
// ./client/app/shared/upload-file/upload-file.service.ts